import { createContext, useEffect, useState } from "react";

import MyLoadingScreen from "../components/MyLoadingScreen";
import { useSite } from "../hooks/useSite";

export const SiteContext = createContext();

export const SiteProvider = ({ children }) => {
  const { useGetSiteInfo } = useSite();

  const [siteInfo, setSiteInfo] = useState({});
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [boards, setBoards] = useState({});

  const { data, isLoading } = useGetSiteInfo({}, (data) => data.data);

  const checkScreenSize = () => {
    const width = window.innerWidth;
    setIsDesktop(width >= 1024);
    setIsTablet(width >= 768 && width < 1023);
    setIsMobile(width < 768);
  };

  const setBoardInfo = (boardCode, data) => {
    const newBoards = { ...boards };
    newBoards[boardCode] = data;
    setBoards(newBoards);
  };

  useEffect(() => {
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (data && !isLoading) {
      setSiteInfo(data);

      if (data.title) {
        document.title = data.title;
      }

      if (data.description) {
        let metaDescription = document.querySelector(
          'meta[name="description"]'
        );
        if (metaDescription) {
          metaDescription.setAttribute("content", data.description);
        } else {
          const newMetaDescription = document.createElement("meta");
          newMetaDescription.name = "description";
          newMetaDescription.content = data.description;
          document.head.appendChild(newMetaDescription);
        }
      }
    }
  }, [data, isLoading]);

  return (
    <SiteContext.Provider
      value={{
        siteInfo,
        setSiteInfo,
        loadingScreen,
        setLoadingScreen,
        isDesktop,
        isMobile,
        isTablet,
        boards,
        setBoards,
        setBoardInfo,
      }}
    >
      {children}
      {loadingScreen && <MyLoadingScreen />}
    </SiteContext.Provider>
  );
};
